<template>
  <main :id="pageIdentifier">
    <slot />
  </main>
</template>

<script>
export default {
  name: 'PageMain',

  computed: {
    /**
     * Generates a unique identifier based on the current route path.
     * This enables Statsig's Visual Editor to uniquely target elements per page,
     * since it builds CSS selectors using [id="..."] attributes in the DOM chain.
     *
     * @returns {string} e.g. 'page--offertes-aanvragen--type-schilderwerk'
     */
    pageIdentifier() {
      const path =
        (this.$route.path || '/')
          .replace(/^\/|\/$/g, '')
          .replace(/\//g, '--') || 'home'
      return `page--${path}`
    },
  },
}
</script>
